<template>
    <div class="factoring-contract-add">
        <InfoContainer
            id="basicForm"
            :infoTitle="contentConfig['infoTitle']"
            :contentConfig="contentConfig['infoContent']"
        >
            <template #basicInfo>
                <avue-form
                    ref="basicInfo"
                    v-model="basicInfoData"
                    :option="formConfig"
                >

                    <template #name>
                        <!-- 存在绑定ID时不可更改项目 -->
                        <CommonSelect
                            bindLabel="name"
                            bindKey="id"
                            bindValue="name"
                            dataUrl="bl/blprojectinfo/page"
                            methods="get"
                            dataMethod="params"
                            searchKey="name"
                            :initParam="initParam"
                            :disabled="$route.params.id && $route.params.id != ''?true:false"
                            :bindId="basicInfoData.projectInfoId?basicInfoData.projectInfoId:''"
                            @handleChange="setProjectInfo"
                        />
                    </template>

                    <!-- 债权人和债务人选择 -->
                    <template #sellerCustId>
                        <CommonSelect
                            bindLabel="custName"
                            bindKey="id"
                            bindValue="custName"
                            methods="get"
                            dataMethod="params"
                            dataUrl="bl/custbasicinformationbl/page"
                            :bindId="basicInfoData.sellerCustId?basicInfoData.sellerCustId:''"
                            @handleChange="setSellerCustId"
                        />
                    </template>
                </avue-form>
            </template>        
        </InfoContainer>

        <InfoContainer
            :infoTitle="fileConfig['infoTitle']"
            :contentConfig="fileConfig['infoContent']"
        >
            <template #fileInfo>
                <Accessory
                    v-if="uploadPermissionNameOne != ''"
                    :idname="uploadPermissionNameTwo"
                    :fileMenuUrlname="uploadPermissionNameOne"
                    :projectid="virtualId"
                    :upload="true"
                    :permissionList="permissionList"
                    :isPermission="true"
                />                
            </template>
        </InfoContainer>

        <InfoContainer
            :infoTitle="commentConfig['infoTitle']"
            :contentConfig="commentConfig['infoContent']"
        >
            <template #commentInfo>
                <!-- 会签意见区 -->
                <CommentBlock ref="commentBlock" :id="virtualId" @fileChange="fileChange"/>
            </template>
        </InfoContainer>

        <div style="width: 100%;height: 40px;"></div>

        <div class="bottom-container">
            <div class="button-container">
                <el-button type="primary" @click="validData(false)">保存</el-button>
                <el-button type="primary" plain @click="validData(true)" v-if="!formData.flowableId">发起流程</el-button>
            </div>
        </div>

    </div>
</template>
<script>
import Accessory from "@/components/accessoriesother/accessory"
import CommonSelect from "@/components/commonSelect/commonSelect"
import InfoContainer from "@/components/infoContainer/infoContainer";
import CommentBlock from "@/components/workflowComponents/commentBlock/commentBlock";
import { contractAddFormConfig } from './contractConfig.js'
import { getPocessName, contractAdd } from '@/api/factoring/factoring'
import workFlow from "@/mixins/workFlow";
export default {
    name: 'FactoringContractAdd',
    mixins: [workFlow],
    data() {
        return {
            initParam: {},
            processKey: 'process_DzNRj7c7p46kXZSfZMHBBjwJ3tp3TA4n',
            formConfig: contractAddFormConfig(),
            basicInfoData: {},
            virtualId: '',
            contentConfig: {
                infoTitle: '新建立项',
                infoContent: [{
                    title: '基础信息',
                    prop: 'basicInfo'
                }]
            }
        }
    },

    components: {
        Accessory,
        InfoContainer,
        CommentBlock,
        CommonSelect
    },
    async created() {
        this.virtualId = this.$route.params.id
        this.basicInfoData.projectInfoId = this.virtualId
        this.getBasicConfigData()
    },    
    methods: {
        async getBasicConfigData() {
            this.processDefinedId = await this.userQueryProcessDefinedId(this.processKey)
            // 获取当前流程文件上传列表权限 permissionList
            this.permissionList = await this.queryTaskUploadDetail(this.processDefinedId, '', true)
            // 设置流程表单路径
            this.queryProcessFormDetail(this.processDefinedId)
        },

        // 设置卖方信息
        setSellerCustId(data) {
            this.basicInfoData.sellerCustId = data.id
            this.basicInfoData.sellerCustName = data.custName
        },

        // 设置选择的项目
        setProjectInfo(data) {
            this.basicInfoData.name = data.name
            this.basicInfoData.number = data.number
            // // 赋值项目相关数据
            this.basicInfoData.projectInfoId = data.id
            this.basicInfoData.sellerCustId = data.sellerCustId
            this.basicInfoData.buyerCustName = data.buyerCustName
            this.basicInfoData.projectType = `${data.projectType}`
            this.basicInfoData.projectComeFrom = `${data.projectComeFrom}`
            this.basicInfoData.factoringCredit = data.factoringCredit
        },

        fileChange() {

        },

        validData(startProcess) {
            let self = this
            this.$refs.basicInfo.validate((valid, done) => {
                if(valid) {
                    // 校验通过, 提交数据
                    self.submitForm(startProcess)
                    done()
                }else{
                    let element = document.getElementById('basicForm')
                    element.scrollIntoView()
                    self.$message({
                        type: 'warning',
                        message: '请补全基础信息数据'
                    })                    
                }
            })
        },

        async submitForm(startProcess) {
            let processInsId = ''
            let params = {
                id: this.virtualId,
                flowableId: '',
                ...this.basicInfoData
            }
            let processNameRes = await getPocessName(params) 
            if(startProcess) {
                // 若存在会签意见附件 带入attchment字段
                let redirectInfo ={
                    url: this.detailFormUrl,
                    id: this.virtualId
                }
                let processParams = {
                    detailFormUrl: JSON.stringify(redirectInfo),
                    processId: this.processDefinedId,
                    comment: this.$refs.commentBlock.$data.opinionContent,
                    attachmentList: this.attchmentList,
                    processInstanceName: processNameRes.data.data.processInstanceName
                }
                processInsId = await this.startWorkFlowProcess(processParams)
            }
            if(processInsId != '') params.flowableId = processInsId
            let res = await contractAdd(params)
            if(res.data.code == 200){
                this.$router.go(-1)
                this.$message({
                    message: '合同新建成功',
                    type: 'success'
                })
            }
        }        
    }
}
</script>
<style lang="scss" scoped>
.factoring-contract-add{
  .submit-con{
    text-align: center;
    margin-bottom: 40px;
    button{
      width: 150px;
    }
  }
  .bottom-container{
    width: 100%;
    height: 70px;
    position: fixed;
    // z-index: 1000;
    bottom: 0px;
    left: 0px;
    z-index: 1000;
    background-color: #fff;
    box-shadow: 0px -8px 10px rgba(0, 0, 0 , 0.05);
    .button-container{
      width: 78%;
      height: 100%;
      margin: 0 auto;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
  }
}
</style>